import { Map } from "immutable";
import * as WithdrawActionType from "../../actions/withdraw/withdraw";
var initialState = Map({
    fetching: false,
    creating: false,
    rates: {},
    providers: [],
    withdrawal: {},
    cancelStatus: undefined,
    error: undefined,
    createWithdrawError: undefined,
    cryptoData: null,
    cryptoDataError: undefined,
    fetchingCryptoData: false,
});
export default (function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case WithdrawActionType.FETCH_WITHDRAW_DATA:
            return state.update("fetching", function () { return true; });
        case WithdrawActionType.SUCCESS_FETCH_WITHDRAW_DATA:
            state = state.update("fetching", function () { return false; });
            state = state.update("creating", function () { return false; });
            if (action.data.error === undefined) {
                state = state.update("rates", function () { return action.data.rates; });
                state = state.update("providers", function () { return action.data.providers; });
                state = state.update("withdrawal", function () { return action.data.withdrawal || {}; });
                return state;
            }
            state = state.update("error", function () { return action.data.error; });
            return state;
        case WithdrawActionType.CANCEL_WITHDRAW:
            return state.update("fetching", function () { return true; });
        case WithdrawActionType.CREATE_WITHDRAW:
            state = state.update("fetching", function () { return true; });
            return state.update("creating", function () { return true; });
        case WithdrawActionType.FETCH_CRYPTO_DATA:
            return state.update("fetchingCryptoData", function () { return true; });
        case WithdrawActionType.SUCCESS_FETCH_CRYPTO_DATA:
            state = state.update("cryptoData", function () { return action.data; });
            state = state.update("cryptoRate", function () { return action.data.Rate; });
            state = state.update("MinAmount", function () { return action.data.MinAmount; });
            state = state.update("fetchingCryptoData", function () { return false; });
            return state.update("cryptoDataError", function () { return undefined; });
        case WithdrawActionType.FAILURE_FETCH_CRYPTO_DATA:
            state = state.update("cryptoDataError", function () { return action.error; });
            return state.update("fetchingCryptoData", function () { return false; });
        case WithdrawActionType.SUCCESS_CREATE_WITHDRAW:
            if (action.data.frameUrl) {
                window.location.href = action.data.frameUrl;
            }
            else {
                state = state.update("creating", function () { return false; });
                state = state.update("fetching", function () { return false; });
                if (action.data.withdrawal !== undefined) {
                    state = state.update("withdrawal", function () { return action.data.withdrawal || {}; });
                }
                else if (action.data.errors) {
                    state = state.update("createWithdrawError", function () { return action.data.errors; });
                }
                else if (action.data.error) {
                    state = state.update("createWithdrawError", function () { return action.data.error; });
                }
                else if (action.data && action.data.Error) {
                    state = state.update("createWithdrawError", function () { return action.data.Error; });
                }
                else {
                    state = state.update("createWithdrawError", function () { return action.data.Result; });
                }
            }
            return state;
        case WithdrawActionType.FAILURE_CREATE_WITHDRAW:
            state = state.update("creating", function () { return false; });
            state = state.update("fetching", function () { return false; });
            return state.update("createWithdrawError", function () { return -10000; });
        case WithdrawActionType.SUCCESS_CANCEL_WITHDRAW:
            state = state.update("fetching", function () { return false; });
            state = state.update("creating", function () { return false; });
            if (action.data.error !== undefined && action.data.error) {
                state = state.update("cancelStatus", function () { return action.data.error.Result; });
            }
            else if (Object.keys(action.data).length === 0 &&
                action.data.constructor === Object) {
                state = state.update("withdrawal", function () { return undefined; });
            }
            return state;
        case WithdrawActionType.CLEAR_WITHDRAW_ERROR:
            return state.update("createWithdrawError", function () { return undefined; });
        default:
            return state;
    }
});



// WEBPACK FOOTER //
// ./src/reducers/withdraw/index.js